<template>
    <PlainPage bgColor="gray-a-f1f1f1">
        <template v-if="!isSuccess">
            <div>
                <RegisterStepper :currentStep="currentStep" />
            </div>
            <div class="mx-5">
                <div v-if="currentStep == 0">
                    <TermsAndCond ref="elemTerms" v-model="states.acceptTerms" />
                    
                    <OrangeButton
                        :customClass="`w-full py-3 text-14 rounded-10 ${!states.acceptTerms ? `bg-a-gray-787878` : `bg-a-orange-f36e21` }`"
                        :disabled="!states.acceptTerms"
                        @click="goToStep(1)">
                        ดำเนินการต่อ
                    </OrangeButton>
                </div>
                <div v-if="currentStep == 1">
                    <InputCitizenForm v-model="states.idCard" @submit="onSubmitIdCard()" :showError="showError" />
                </div>
                <div v-if="currentStep == 2">
                    <SmsRegisterOtp @success="finishRegister()" />
                </div>
            </div>
        </template>
        <template v-else>
            <SmsRegisterSuccess />
        </template>
    </PlainPage>
</template>

<script>
import { defineComponent, inject, reactive, ref, onMounted } from 'vue';
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
import useAlertNonBtnModal from "@/helper/composable/modal/useAlertNonBtnModal"
import RegisterApi from '../service/RegisterApi';
import { RegisterSmsCheckContactNumberModel } from "../model/SmsRegisterModel"
import { useTracking } from "@/feature/TrackingFeature"

// component
import PlainPage from '@/components/Layout/Page/PlainPage.vue';
import RegisterStepper from "../component/SmsRegister/RegisterStepper.vue"
import TermsAndCond from '../component/SmsRegister/TermsAndCond.vue';

import InputCitizenForm from '../component/SmsRegister/InputCitizenForm.vue';
import SmsRegisterOtp from '../component/SmsRegister/SmsRegisterOtp.vue';
import SmsRegisterSuccess from '../component/SmsRegister/SmsRegisterSuccess.vue';
import OrangeButton from '../../../components/Button/OrangeButton.vue';

export default defineComponent({
    components: {
        PlainPage,
        RegisterStepper,
        TermsAndCond,
        // MainButton,
        InputCitizenForm,
        SmsRegisterOtp,
        SmsRegisterSuccess,
        OrangeButton
    },
    setup: function () {
        const elemTerms = ref(null)
        const modalStore = inject("ModalStore")
        const { alertNonBtnModal } = useAlertNonBtnModal(modalStore)
        const { loadingModal } = useLoadingModal(modalStore)

        const currentStep = ref(0)
        const isSuccess = ref(false)
        const showError = ref(false)
        const states = reactive({
            acceptTerms: false,
            idCard: ""
        })
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        const chekcingIdCard = function () {
            let reqModel = new RegisterSmsCheckContactNumberModel()
            reqModel.citizenid = states.idCard
            reqModel.is_accepted = states.acceptTerms

            return RegisterApi.apiCheckContactNumber(reqModel.getParams())
        }

        const goToStep = function (step) {
            currentStep.value = step
            if(step == 1) {
                tracking.event("register_sms_page", "click_continue", "", "");
            }
        }

        const onSubmitIdCard = function () {

            tracking.event("register_sms_page", "click_submit", "", "");

            loadingModal.show()
            chekcingIdCard().then(result => {
                console.log(result)
                if (!result) {
                    // show popup error
                    console.log(alertNonBtnModal)
                    alertNonBtnModal
                        .clearModal()
                        .setTitle("ขออภัย")
                        .setMsg("ไม่พบเบอร์โทรศัพท์มือถือของท่านในระบบ กรุณาติดต่อศูนย์บริการลูกค้า<br />โทร. 02-308-9222")
                        .show()
                } else {
                    goToStep(2)
                }
            }).catch(()=>{
                showError.value = true
            }).finally(() => {
                loadingModal.hide()
            })
        }

        const finishRegister = function () {
            isSuccess.value = true
        }

        onMounted(() => {
            tracking.screenName('register_sms')
            tracking.event("register_sms_page", "view_terms_cons", "", "");
        })

        return {
            elemTerms,
            currentStep,
            isSuccess,
            states,
            showError,
            goToStep,
            onSubmitIdCard,
            finishRegister
        }
    },
})
</script>

<style lang="scss" scoped>
@import "@/style/animation/modal-animation.scss";
</style>
